<template>
  <div>
    <v-col cols="12" class="mx-auto">
      <v-checkbox
          v-if="displayGates && ['admin', 'admin-engineer'].includes(this.roleName)"
          v-model="isMassDoorphones"
          hide-details
          dense
          color="success"
          label="Добавить несколько домофонов"
          class="checkbox mt-2 mb-2"
        ></v-checkbox>
      <div class="mx-auto">
        <v-btn
          v-if="displayGates"
          color="#1E6CEB"
          dark
          dense
          class="text-none"
          @click="getPossibleDoorphones"
        >
          привязать домофон
        </v-btn>
        <v-btn
          v-if="displayMain"
          color="error"
          dark
          class="ma-2 text-none"
          @click.stop="popupToUntieDoorphone = true"
        >
          отвязать домофон
        </v-btn>
      </div>
      <v-card-text v-if="displayMain">Привязанные домофоны к калитке.</v-card-text>
      <v-card-text v-if="!displayMain && this.doorphone.type === 'G'">Нет привязанных домофонов.</v-card-text>
      <v-data-table
        v-if="displayMain"
        class="table"
        item-key="id"
        :items="doorphone.mainDoorphones"
        :items-per-page="5"
        :headers="headersAttachedDoorphones"
        :footer-props="{
            'items-per-page-options': [5, 10],
          }"
      >
        <template v-slot:item.address="{ item }">
          <router-link class="routerLink" :to="`/doorphones/${item.id}`">
            {{ getDoorphoneAddress(item) }}
          </router-link>
        </template>
      </v-data-table>
    </v-col>

    <v-dialog
      v-model="popupBindDoorphones"
      max-width="600"
      lazy-validation
    >
      <v-card class='pb-5'>
        <v-progress-linear v-if="loadingListDoorphones" indeterminate color="primary"></v-progress-linear>
        <v-card-title class="headline">
          Привязать домофон
          <v-spacer></v-spacer>
          <v-btn
            icon
            text
            x-large
            class="btn__icon pa-0"
            width="18"
            height="18"
            @click.prevent="popupBindDoorphones = false"
          >
            <v-icon size="x-large">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-col class="px-5 pb-5">
          <v-text-field
            v-model="searchAddress"
            placeholder="Поиск по адресу"
            solo
            outlined
            dense
            hide-details
            flat
            @keyup.enter="onSearchDoorphones"
          ></v-text-field>
        </v-col>
        <v-col class="px-5 pb-5">
          <v-text-field
            v-model="searchId"
            placeholder="Поиск по id"
            solo
            outlined
            dense
            hide-details
            flat
            @keyup.enter="onSearchDoorphones"
          ></v-text-field>
        </v-col>
        <v-row class="pa-4 px-5">
            <v-col>
              <v-btn
                color="green"
                outlined
                class="text-none mr-2"
                rounded
                @click.prevent="addDoorphone()"
              >
                Привязать
              </v-btn>
            </v-col>
            <v-spacer></v-spacer>
            <v-col class="text-right">
              <v-btn
                dark
                class="btn primary darken-3 white px-7 text-none"
                @click="onSearchDoorphones"
              >
                Поиск
              </v-btn>
            </v-col>
          </v-row>
        <v-col class="px-5 pb-5">
          <v-checkbox
            v-model="isWithoutPrefix"
            hide-details
            dense
            :disabled="isMassDoorphones"
            color="success"
            label="Добавить без префикса"
            class="checkbox mb-5"
          ></v-checkbox>
        </v-col>
        <v-col class="px-5 pt-0 pb-0" v-if="isMassDoorphones">
          <div class="body-2 grey--text text--darken-1">
            Можно выбрать максимум 10 домофонов
          </div>
        </v-col>
        <v-data-table
          class="table mx-5 pb-5"
          :items-per-page="doorphonesPerPage"
          :items="filteredDoorphone"
          :headers="headersTieDoorphones"
          :footer-props="{
            'items-per-page-options': [10, 20, 50, 100],
            'items-per-page-text': 'На странице',
          }"
          :page.sync="doorphonesPage"
          :server-items-length="doorphonesTotal"
          @update:page="onDoorphonesPageChange"
          @update:items-per-page="onDoorphonesPerPageChange"
        >
          <template v-slot:item.address="{ item }">
            {{ getDoorphoneAddress(item) }}
          </template>
          <template v-slot:item.actions="{ item }">
            <v-radio-group
              v-if="!isMassDoorphones"
              v-model="selected"
              class="center"
            >
              <v-radio
                :value="item.id"
                @change="selectedOfDoorphone(item)"
              />
            </v-radio-group>
            <v-checkbox
              v-else
              class="center"
              v-model="selected"
              :value="item.id"
              @change="selectedOfDoorphone(item)"
            />
          </template>
        </v-data-table>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="popupApartmentPrefix"
      persistent
      :retain-focus="false"
      max-width="420">
      <v-card>
        <v-card-title class="pb-0">Установите префикс для квартир.</v-card-title>
        <v-card-text class="pa-0 pl-6">Будьте внимательны при выборе префикса.</v-card-text>
        <v-col>
          <v-text-field
            label="префикс для квартир"
            v-model.number="apartmentPrefix"
            :rules="[
                              v => !!v || 'Обязательное поле',
                              v => v >= 0 || 'Введите целое число',
                            ]"
            type="number"
            outlined
            dense
            flat
            required
            autofocus
          ></v-text-field>
          <v-card-text v-if="displayMain" class="pa-0 pl-16">Привязанные домофоны к калитке.</v-card-text>
          <v-data-table
            v-if="displayMain"
            class="table"
            item-key="id"
            hide-default-footer
          >
            <template v-slot:header>
              <thead>
              <tr>
                <th>id</th>
                <th>Адрес</th>
                <th>Префикс</th>
              </tr>
              </thead>
            </template>
            <template v-slot:body>
              <tbody>
              <tr v-for="doorphone in doorphone.mainDoorphones" :key="doorphone.id">
                <td>{{doorphone.id}}</td>
                <td>{{ getDoorphoneAddress(doorphone) }}</td>
                <td class="pl-8 pr-0">{{doorphone.apartment_prefix}}</td>
              </tr>
              </tbody>
            </template>
          </v-data-table>
        </v-col>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="success"
            text
            @click.prevent="dialogAddDoorphone = true"
            :disabled="apartmentPrefix === ''"
          >
            Привязать домофон
          </v-btn>
          <v-btn
            color="primary"
            text
            @click.prevent="BackApartmentPrefix()"
          >
            назад
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogAddDoorphone"
      max-width="350"
    >
      <v-card>
        <v-card-title class="headline">Привязать домофон?</v-card-title>
        <v-card-text>Подтверждая, вы привязываете домофон.</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary darken-1"
            text
            @click.prevent="dialogAddDoorphone = false"
          >
            Отменить
          </v-btn>
          <v-btn
            color="success"
            text
            :loading="loading"
            @click.prevent="bindGateDoorphone(apartmentPrefix)"
          >
            привязать
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="popupToUntieDoorphone"
      max-width="550">
      <v-card>
        <v-card-title class="pl-14">Отвязать домофон у калитки</v-card-title>
        <v-data-table
          class="table"
          item-key="id"
          :items-per-page="10"
          :footer-props="{
              'items-per-page-options': [5, 10, 30],
          }"
        >
          <template v-slot:header>
            <thead>
            <tr>
              <th>id</th>
              <th>Адрес</th>
              <th></th>
            </tr>
            </thead>
          </template>
          <template v-slot:body>
            <tbody>
            <tr v-for="doorphone in doorphone.mainDoorphones" :key="doorphone.id">
              <td>{{doorphone.id}}</td>
              <td>{{ getDoorphoneAddress(doorphone) }}</td>
              <td>
                <v-row justify="center">
                  <v-btn
                    icon
                    text
                    small
                    class="btn__icon pa-0"
                    width="18"
                    height="18"
                    @click.prevent="openDialogRemoveDoorphone(doorphone)"
                  >
                    <v-icon size="large">mdi-close</v-icon>
                  </v-btn>
                </v-row>
              </td>
            </tr>
            <v-dialog
              v-model="dialogRemoveDoorphone"
              max-width="350"
            >
              <v-card>
                <v-card-title class="headline">Отвязать домофон?</v-card-title>
                <v-card-text>Подтверждая, вы отвяжите домофон.</v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="primary darken-1"
                    text
                    @click.prevent="backDialogRemove()"
                  >
                    Отменить
                  </v-btn>
                  <v-btn
                    color="primary darken-1"
                    text
                    :loading="loading"
                    @click.prevent="removeGateDoorphone()"
                  >
                    Отвязать
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            </tbody>
          </template>
        </v-data-table>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="resultDialog"
      max-width="600"
      lazy-validation
      content-class="dialog-border-radius"
    >
      <v-card>
        <v-card-title class="headline">
          Результат массовой привязки
          <v-spacer></v-spacer>
          <v-btn
            icon
            text
            x-large
            class="btn__icon pa-0"
            width="18"
            height="18"
            @click.prevent="resultDialog = false"
          >
            <v-icon size="x-large">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <div v-if="massResult.summary" class="mb-4">
            <div>Статус: {{ massResult.summary.status ? 'успешно' : 'ошибка' }}</div>
            <div>Успешно: {{ massResult.summary.success_count }} / {{ massResult.summary.total_count }}</div>
          </div>
          <v-data-table
            class="table"
            :items-per-page="10"
            :items="massResult.results"
            :headers="headersMassResult"
          >
            <template v-slot:item.status="{ item }">
              <span :class="item.status ? 'green--text' : 'red--text'">{{ item.status ? 'успех' : 'ошибка' }}</span>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'EditGate',
  props: {
    intercomManufacturer: String,
  },
  data: () => {
    return {
      loading: false,
      attachedDoorphones: [],
      filteredDoorphone: [],
      address: '',
      popupApartmentPrefix: false,
      isWithoutPrefix: false,
      dialogAddDoorphone: false,
      dialogRemoveDoorphone: false,
      apartmentPrefix: [],
      selected: [],
      selectedDoorphone: {},
      isDisabled: true,
      popupBindDoorphones: false,
      popupToUntieDoorphone: false,
      isMassDoorphones: false,
      doorphones: [],
      selectedDoorphones: [],
      searchAddress: '',
      searchId: '',
      doorphoneId: [],
      loadingListDoorphones: false,
      cachedListDoorphones: null,
      headersTieDoorphones: [
        { text: 'id', value: 'id' },
        { text: 'Адрес', value: 'address' },
        { text: 'Модель', value: 'device.model', sortable: false },
        { text: '', value: 'actions' },
      ],
      headersAttachedDoorphones: [
        { text: 'id', value: 'id' },
        { text: 'Адрес', value: 'address', sortable: false },
        { text: 'Префикс', value: 'apartment_prefix', sortable: false },
      ],
      headersMassResult: [
        { text: 'ID домофона', value: 'doorphone_id' },
        { text: 'Статус', value: 'status' },
        { text: 'Префикс', value: 'apartment_prefix' },
      ],
      include: ['mainDoorphones'],
      doorphonesPage: 1,
      doorphonesPerPage: 20,
      doorphonesTotal: 0,
      doorphonesMeta: null,
      doorphonesLinks: null,
      resultDialog: false,
      massResult: {
        summary: null,
        results: [],
      },
    };
  },
  created () {
  },
  computed: {
    ...mapGetters({
      doorphone: 'Doorphone/doorphoneEditDoorphone',
      doorphonesArrays: 'Doorphone/doorphonesExpanded',
      roleName: 'roleName',
    }),
    displayMain () {
      return !!(this.doorphone.mainDoorphones[0] && this.$checkPermission('remove_doorphone_gate'));
    },
    displayGates () {
      return this.doorphone.type === 'G' && this.$checkPermission('add_doorphone_gate');
    },
    typeVerification () {
      return this.doorphone.type === 'G';
    },
  },
  methods: {
    ...mapActions({
      deleteGateDoorphone: 'Gate/deleteGateDoorphone',
      addGateDoorphone: 'Gate/addGateDoorphone',
      getDoorphones: 'Doorphone/getExpandedDoorphones',
      massAddGateDoorphones: 'Gate/massAddGateDoorphones',
      getInfoDoorphoneEdit: 'Doorphone/getInfoDoorphoneEdit',
    }),
    async getPossibleDoorphones () {
      this.selected = this.isMassDoorphones ? [] : null;
      this.isDisabled = true;
      if (this.cachedListDoorphones) {
        this.filteredDoorphone = this.cachedListDoorphones;
        this.popupBindDoorphones = true;
        return;
      }
      if (this.typeVerification) {
        this.popupBindDoorphones = true;
        this.loadingListDoorphones = true;
        await this.loadDoorphones(1);
      }
    },
    BackApartmentPrefix () {
      this.selectedDoorphones = this.selectedDoorphones.filter(doorphone => doorphone.id);
      this.popupApartmentPrefix = false;
    },
    addDoorphone () {
      if (this.isMassDoorphones) {
        if (Array.isArray(this.selected) && this.selected.length > 0) {
          const selectedItems = this.filteredDoorphone.filter(d => this.selected.includes(d.id));
          const doorphoneIds = selectedItems.map(d => d.id);
          const apartmentPrefixes = selectedItems.map(d => {
            const raw = (d.address || '').toString();
            const part = raw.split(', д.').pop();
            return part ? part.replace(/\D+/g, '') : '';
          });

          this.dialogAddDoorphone = true;
          this._massPayload = { doorphoneIds, apartmentPrefixes };
          this.isDisabled = false;
        } else {
          this.$flash_danger('Выберите домофон');
        }
        return;
      }
      if (!this.selected || (Array.isArray(this.selected) && this.selected.length === 0)) {
        this.$flash_danger('Выберите домофон');
        return;
      }
      const doorphone = this.filteredDoorphone.find(d => d.id === this.selected) || null;
      if (!doorphone) {
        this.$flash_danger('Выберите домофон');
        return;
      }
      this.doorphones.push(doorphone);
      this.apartmentPrefix = doorphone.apartmentPrefix;
      if (!this.isWithoutPrefix) {
        this.popupApartmentPrefix = true;
      } else {
        this.dialogAddDoorphone = true;
      }
    },
    getDoorphoneAddress (doorphone) {
      let address = doorphone.address;
      if (doorphone.entrance > 0) {
        address = `${doorphone.address}, п.${doorphone.entrance}`;
      }
      return address;
    },
    bindGateDoorphone (apartmentPrefix) {
      if (this.isMassDoorphones && this._massPayload) {
        const doorphoneIds = this._massPayload.doorphoneIds;
        const apartmentPrefixes = this.isWithoutPrefix ? [] : this._massPayload.apartmentPrefixes;
        this.popupBindDoorphones = false;
        this.popupApartmentPrefix = false;
        this.dialogAddDoorphone = false;
        this.popupToUntieDoorphone = false;
        this.loading = true;
        this.massAddGateDoorphones({
          gateId: this.$route.params.id,
          doorphone_ids: doorphoneIds,
          apartment_prefixes: apartmentPrefixes,
          without_apartment_prefix: this.isWithoutPrefix,
        })
          .then(async (response) => {
            this.$flash_success('Домофоны успешно привязаны');
            try {
              await this.getInfoDoorphoneEdit({ id: this.$route.params.id });
            } catch (e) {
            }
            const data = response && response.data ? response.data : {};
            this.massResult.summary = {
              status: data.status,
              success_count: data.success_count,
              total_count: data.total_count,
            };
            this.massResult.results = Array.isArray(data.results) ? data.results : [];
            this.resultDialog = true;
          })
          .catch((err) => {
            console.error(err);
            this.$flash_warning('Ошибка при массовой привязке домофонов');
          })
          .finally(() => {
            delete this._massPayload;
            this.cancelBindDoorphone();
          });
        return;
      }

      const doorphone = this.doorphones[this.doorphones.length - 1];
      this.selectedDoorphones.push({
        id: doorphone.id,
        address: doorphone.address,
        apartment_prefix: apartmentPrefix,
      });
      this.popupBindDoorphones = false;
      this.popupApartmentPrefix = false;
      this.dialogAddDoorphone = false;
      this.popupToUntieDoorphone = false;
      this.loading = true;
      this.addGateDoorphone({
        gateId: this.$route.params.id,
        doorphoneId: this.selectedDoorphones.map(doorphone => doorphone.id),
        apartment_prefix: this.apartmentPrefix,
        without_apartment_prefix: this.isWithoutPrefix,
      })
        .then(async () => {
          this.$flash_success('Домофон успешно Привязан');
          try {
            await this.getInfoDoorphoneEdit({ id: this.$route.params.id });
          } catch (e) {
            console.error('Ошибка при обновлении информации о домофоне:', e);
          }
        })
        .catch((err) => {
          console.error(err);
          if (err.response && err.response.status === 422) {
            const error = err.response.data.gate;
            error.forEach(item => {
              this.$flash_danger('Ошибка: ' + item);
            });
          } else {
            this.$flash_warning('Ошибка при привязки домофона');
          }
          this.selectedDoorphones = this.selectedDoorphones.filter(doorphone => this.doorphoneId.includes(doorphone.id));
        })
        .finally(() => {
          this.cancelBindDoorphone();
        });
    },
    openDialogRemoveDoorphone (doorphone) {
      this.doorphoneId.push(doorphone.id);
      this.dialogRemoveDoorphone = true;
    },
    removeGateDoorphone () {
      this.deleteGateDoorphone({
        gateId: this.$route.params.id,
        doorphoneId: this.doorphoneId,
      })
        .then(async () => {
          this.$flash_success('Домофон успешно отвязан');
          try {
            await this.getInfoDoorphoneEdit({ id: this.$route.params.id });
          } catch (e) {}
        })
        .catch(() => {
          this.$flash_warning('Ошибка при отвязки домофона');
        })
        .finally(() => {
          this.cancelBindDoorphone();
          this.doorphoneId = [];
        });
      this.loading = true;
    },
    cancelBindDoorphone () {
      this.popupBindDoorphones = false;
      this.popupApartmentPrefix = false;
      this.popupToUntieDoorphone = false;
      this.dialogAddDoorphone = false;
      this.loading = false;
      this.dialogRemoveDoorphone = false;
      this.value = '';
      this.searchAddress = '';
      this.searchId = '';
    },
    backDialogRemove () {
      this.doorphoneId = this.doorphoneId.filter(doorphone => doorphone.id);
      this.dialogRemoveDoorphone = false;
    },
    selectedOfDoorphone (item) {
      if (this.isMassDoorphones) {
        this.isDisabled = !(Array.isArray(this.selected) && this.selected.length > 0);
      } else {
        this.isDisabled = !this.selected;
        this.selectedDoorphone = this.filteredDoorphone.find(d => d.id === this.selected) || {};
      }
    },
    loadDoorphones (page = 1) {
      this.loadingListDoorphones = true;
      return this.getDoorphones({
        pagination: 1,
        page: page,
        limit: this.doorphonesPerPage,
        filters: {
          type: 'M',
          manufacturer: this.intercomManufacturer,
          agent_id: this.doorphone.agent_id,
          address: this.searchAddress,
          id: this.searchId,
        },
        include: ['device'],
      })
        .then((data) => {
          this.attachedDoorphones = this.doorphone.mainDoorphones.map(doorphone => doorphone.id);
          this.filteredDoorphone = data.doorphones.filter(d => !this.attachedDoorphones.includes(d.id));
          this.doorphonesMeta = data.meta;
          this.doorphonesLinks = data.links;
          this.doorphonesTotal = data.meta ? data.meta.total : 0;
          this.doorphonesPage = page;
          data.doorphones.forEach((doorphone) => {
            doorphone.apartmentPrefix = doorphone.address.split(', д.').pop().replace(/\D+/g, '');
          });
        })
        .finally(() => {
          this.loadingListDoorphones = false;
        });
    },
    onDoorphonesPageChange (page) {
      this.loadDoorphones(page);
    },
    onDoorphonesPerPageChange (newPerPage) {
      this.doorphonesPerPage = newPerPage;
      this.doorphonesPage = 1;
      this.loadDoorphones(1);
    },
    onSearchDoorphones () {
      this.doorphonesPage = 1;
      this.loadDoorphones(1);
    },
  },
  watch: {
    selected (newVal) {
      if (this.isMassDoorphones && Array.isArray(newVal) && newVal.length > 10) {
        this.selected = newVal.slice(0, 10);
        this.$flash_danger('Можно выбрать максимум 10 домофонов');
      }
    },
    isMassDoorphones (newVal) {
      this.selected = newVal ? [] : null;
      this.isDisabled = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.routerLink {
  text-decoration: none;
}

.v-application a {
  color: #434850;
}

a:hover.routerLink {
  text-decoration: underline;
}
</style>
